import { useEffect, useState } from "react";
import api from "../../../api/ApiService";
import { applicationLogsTableColumns } from "../../../config/tableColumns";
import Table from "../../common/Table/Table";
import { formatDateTime } from "../../../utils/utils";
import {
  applicationStageList,
  applicationStatusList,
} from "../../../config/applicationStatusConfig";
import RemarksView from "./RemarksView";
import { BASE_URL } from "../../../config/apiConfig"; // ✅ import your base URL
import Button from "../../common/Button";

const ApplicationLogTab = ({ applicationId, userId, docsResponse }) => {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const response = await api.post("/user/application/logs", {
          application_id: applicationId,
          user_id: userId,
        });

        if (response.data && Array.isArray(response.data)) {
          const formatted = response.data.map((item, index) => {
            const documentNames = [];
            if (item.document_type_id && docsResponse) {
              const ids = item.document_type_id
                .split(",")
                .map((id) => id.trim());
              ids.forEach((id) => {
                const doc = docsResponse.find((d) => String(d.id) === id);
                if (doc) {
                  documentNames.push(doc.name_en);
                }
              });
            }

            return {
              sr_no: index + 1,
              created_at: formatDateTime(item.created_at),
              status: applicationStatusList.find(
                (status) => status.value === item.status
              )?.label,
              stage: applicationStageList.find(
                (stage) => stage.value === String(item.stage)
              )?.label || "Nodal",
              remarks: (
                <RemarksView
                  remarks={item.remarks}
                  documentNames={documentNames}
                />
              ),
              uploaded_report: item.uploaded_report ? (
                <Button
                  onClick={() =>
                    window.open(`${BASE_URL}/${item.uploaded_report}`, "_blank")
                  }
                  className="px-4 py-2 bg-btn text-white rounded hover:opacity-90"
                >
                  View Report
                </Button>
              ) : (
                "N/A"
              ),
            };
          });
          setLogs(formatted);
        }
      } catch (error) {
        console.error("Failed to fetch application logs", error);
      }
    };
    fetchLogs();
  }, [applicationId, userId]);

  return (
    <div className="rounded p-3 bg-white">
      <div className="bg-white border rounded mb-3">
        <div className="px-4 py-3 border-b bg-btn rounded">
          <p className="font-bold text-white">Application Logs</p>
        </div>
        <Table columns={applicationLogsTableColumns} data={logs} />
      </div>
    </div>
  );
};

export default ApplicationLogTab;
